<template>
  <el-submenu
    :index="data.url"
    :popper-append-to-body="false"
    :class="[`${data.url === activeMenuName ? 'active' : ''}`]"
  >
    <template slot="title">
      <span class="submenu-title">{{ data.name }}</span>
    </template>
    <template v-for="item in data.children">
      <child-menu v-if="item.children" :data="item" :key="item.id" />
      <el-menu-item
        :index="item.url"
        v-else
        :key="item.id"
        @click="$router.push({ path: item.url })"
      >
        {{ item.name }}
      </el-menu-item>
    </template>
  </el-submenu>
</template>

<script>
export default {
  name: 'child-menu',
  props: ['data'],
  data() {
    return {
      activeMenuName: '/' + window.location.hash.slice(1).split('/')[1],
    }
  },
  watch: {
    $route(newValue) {
      let { path } = newValue
      path = '/' + path.split('/')[1]
      if (path !== this.activeMenuName) this.activeMenuName = path
    },
  },
}
</script>

<style scoped lang="scss">
.el-menu--popup {
  .submenu-title {
    color: #909399;

    &:hover {
      color: #000;
    }
  }
}

.active {
  background-image: linear-gradient(46deg, #fe7301 0%, #af0409 100%);
  border-radius: 8px;
}
</style>
